/**
 * OVERRIDE DefaultBody.jsx
 * REASON: Adding Button and flagAlign in slider block.
 * FILE: https://github.com/kitconcept/volto-slider-block/blob/master/src/components/DefaultBody.jsx
 * DATE: 2023-08-02
 * DEVELOPER: @iRohitSingh
 */

import SliderBody from '../../../../components/Blocks/Slider/DefaultBody';

export default SliderBody;
